export const CONTACT_US = "CONTACT_US"
export const CONTACT_US_SUCCESSFUL = "CONTACT_US_SUCCESSFUL"
export const CONTACT_US_FAILED = "CONTACT_US_FAILED"
export const CONTACT_US_RESET = "CONTACT_US_RESET"